import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {ApiBaseService, VendorsService} from '../../../../../../projects/vendors/src/public-api';
import {ApiEnum} from '../../../../@application/enum/api.enum';
import {OrderStatus} from '../../../../@application/enum/order-status.enum';
import {Subscription} from "rxjs";

@Component({
    selector: 'app-ongoing-order-status',
    templateUrl: './ongoing-order-status.component.html',
    styleUrl: './ongoing-order-status.component.scss',
    standalone: false
})
export class OngoingOrderStatusComponent implements OnInit, OnDestroy {

  ongoingOrders = [] as any[];
  apiBaseService = inject(ApiBaseService);
  vendorsService = inject(VendorsService);
  orderStatus = OrderStatus
  newOrderSubscription!: Subscription;
  orderCloseSubscription!: Subscription;
  orderStatusSubscription!: Subscription;

  ngOnInit(): void {
    this.dataSubscriptions()
    this.getData();
  }

  private dataSubscriptions() {
    this.newOrderSubscription = this.vendorsService.newOrderSubject.subscribe({
      next: newOrder => {
        if (newOrder)
          this.getData();
      }
    })
    this.orderCloseSubscription = this.vendorsService.orderCloseSubject.subscribe({
      next: orderClose => {
        if (orderClose)
          this.getData();
      }
    })
    this.orderStatusSubscription = this.vendorsService.orderStatusSubject.subscribe({
      next: orderStatus => {
        if (orderStatus)
          this.getData();
      }
    })
  }

  private getData() {
    this.apiBaseService.GET<any[]>([ApiEnum.RestaurantModule, ApiEnum.Order, ApiEnum.DashBoard, ApiEnum.OnGoingOrderCount])
      .subscribe({
        next: response => {
          this.ongoingOrders = response;

        }
      })
  }

  ngOnDestroy(): void {
    this.newOrderSubscription.unsubscribe();
    this.orderCloseSubscription.unsubscribe();
    this.orderStatusSubscription.unsubscribe();
  }

}
